/* import __COLOCATED_TEMPLATE__ from './loading-skeleton.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();